/* eslint-disable no-console */
import Wrap, {
  StyledButton as Button, InfoMessage
} from './styles';

import WMS from 'services/crud/WMS';
import Layer from 'services/models/Layer';

import LayersGeoserviceList from './components/LayersGeoserviceList';

import MobileHeader from '../../../../../MobileHeader';

import AppContext from 'views/MapView/services/context';

import Icon from '@map/components/Icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 */
import { useState, useContext } from 'react';
import Mobile from 'views/MapView/components/Mobile';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 * 
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useModule, useMap } from 'views/MapView/hooks';

export default () => {
  const [showingDetails, setShowingDetails] = useState(false);  
  const [selected, setSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [highlightFirstLayer, setHighlightFirstLayer] = useState(false);
  const [resquestedGeoservice, setResquestedGeoservice] = useState(false);
  const [showInput, setshowInput] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  // Lista de camadas
  const [listWorkspaceLayers, setListWorkspaceLayers] = useState(null);

  // Campo de url do geoserviço
  const [urlService, setUrlService] = useState('');  

  const context = useContext(AppContext);
  const { genericSetContextProp } = context;
  const { activeModule } = useModule();
  const { addLayer } = useMap();

  const getLayersListSelection = (paramSelected) => {
    setSelected(paramSelected);
  };

  /**
   * Identifica submit do campo de url do geoserviço
   */
  const keyPressUrlGeoservice = (event) => {    
    // Se pressionado a tecla "enter" ou evento do tipo "click"
    if((event.keyCode === 13 || event.type === 'click') 
      && !isStrEmpty(urlService)) {
        startRequest();
    }
  };

  /**
   * Realiza requisição do geoserviço
   */
  const startRequest = () => {
    setListWorkspaceLayers(null);
    setLoading(true);
    setHighlightFirstLayer(false);
    setResquestedGeoservice(true);
    getLayersFromService(urlService)
      .then((workspaceLayers) => {        
        // Obtém nome da camada através da URL do serviço
        let layerNameParam = getLayerNameParam(urlService);
        // Obtém o camada a ser destacada
        let layerToHighlight = workspaceLayers.find((l) => l.Name === layerNameParam);  
          
        if (layerToHighlight) {
          // Obtém lista de camadas com exceção da camada a ser destacada
          let wlFilter = workspaceLayers.filter(
            function (wl)
            {
              return wl.Name !== layerNameParam;
            }
          );
          // Adiciona camada a ser destacada no início da lista
          wlFilter.unshift(layerToHighlight);
          workspaceLayers = wlFilter;          
          setHighlightFirstLayer(true);
        }
        setListWorkspaceLayers(workspaceLayers);        
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /**
   * Identifica submit do campo de url do geoserviço
   */
  const clearFormGeoservice = () => {
    setUrlService('');
    setResquestedGeoservice(false);
    setListWorkspaceLayers(null);
    setshowInput(false)
    setSearchQuery(null)
  };

  /**
   * Obtém as camadas do workspace do serviço
   */
  const getLayersFromService = async (url) => {    
    let workspaceLayers = null;
    try {
      /**
       * Obtém as layers do workspace do serviço
      */ 
      const getLayers = (capabilityLayers) => {        
        let returnLayers = [];        
        if (Array.isArray(capabilityLayers)) {               
          capabilityLayers.forEach((l) => {
            if (l.Layer) {
              returnLayers = [...returnLayers, ...getLayers(l.Layer)];
            } else {
              returnLayers.push(l);
            }
          });
        } else if (capabilityLayers.Layer) {          
          if (!Array.isArray(capabilityLayers.Layer)) {
            returnLayers.push(capabilityLayers.Layer);
          } else {
            returnLayers = [
              ...returnLayers,
              ...getLayers(capabilityLayers.Layer),
            ];
          }
        } else {          
          returnLayers = [
            ...returnLayers,
            capabilityLayers,
          ];
        }       
        return returnLayers;
      };
      
      // Obtém o serviço base do serviço fornecido
      let urlServiceBase = getServiceBaseLink(url);
      // Obtém os capabilities do serviço da camada externa
      let getCapabilities = await WMS.getCapabilities(urlServiceBase);      
      // Obtém as layers do workspace do serviço
      workspaceLayers = getLayers(getCapabilities.data.metadados.Capability.Layer);
      
    } catch (error) {
      console.error(
        `Erro na requisição do geoserviço`,
        error
      );
    }
    return workspaceLayers;
  };

  /**
   * Obtém o link base do serviço
   * @param {String} urlGeoservice 
   */
  const getServiceBaseLink = (urlGeoservice) => {
    return `${urlGeoservice.replace(/\?[\w\W]+/, '')}`;    
  };

  /**
   * Adiciona camadas selecionadas do geoserviço ao mapa
   */
  const addGeoserviceLayersToMap = () => {
    selected.forEach((selectedLayer) => {
      let layerToAdd = createLayerFromExternalGeoservice(selectedLayer);      
      // Adiciona layer ao mapa               
      addLayer(layerToAdd, null, true);
    });
    genericSetContextProp('layersCatalogIsOpened', false);      
  };

  /**
   * Cria um objecto layer a partir do item geoservice
   * @param {Object} itemGeoservice 
   */
  const createLayerFromExternalGeoservice = (itemGeoservice) => {
    // Cria objeto Layer
    let layer = new Layer(
      null,
      'externa',
      null,
      itemGeoservice.Name,
      null,
      null,
      null,
      null,
      null
    );
    layer.loadDataGeoservice(urlService, itemGeoservice);

    return layer;
  };

  /**
   * Obtém o parametro nome da camada a partir da url do serviço
   * @param {String} linkFullService
   */
  const getLayerNameParam = (linkFullService) => {
    let layerName = linkFullService 
      ? linkFullService.match(/(layers=)[\w\W]+/)
      : null;
    layerName = layerName
      ? layerName[0]
          .split('&')[0]
          .split('%3A')[1]
      : null;
    return layerName;      
  }

  /**
   * Verifica se uma string está vazia
   * @param {String} str
   */
  const isStrEmpty = (str) => {
    return (!str || str.length === 0 );
  }

  /**
   * @returns Um header onde é possivel inserir o link do geoserviço,
   * escolher camadas e ter um preview dela no quadro e adciona-las no mapa
   */
  return (
    <Wrap showingDetails={showingDetails}>
      {showingDetails && (
        <Mobile>
          <MobileHeader
            className="fixed_header"
            title="Detalhe de Camada"
            onClick={(e) => setShowingDetails(false)}
          />
        </Mobile>
      )}
      <aside>
        <header>
          <div className="content-input-geoservice">
            <Input
              type="text"
              placeholder="Inserir link do geoserviço"
              value={urlService}
              fullWidth              
              onKeyDown={keyPressUrlGeoservice}
              onChange={(e) => {
                setResquestedGeoservice(false);                
                setUrlService(e.target.value)
              }}
              className="text-field"
              />
            <button
              className="geoservice-request"
              onClick={(e) => {
                resquestedGeoservice ? clearFormGeoservice() : keyPressUrlGeoservice(e);
              }}
            >              
              <Icon
                  i={resquestedGeoservice
                      ? "map-geoservice-clearurl"
                      : "map-geoservice-requestarrow"
                    }
              />
            </button>
          </div>       
          {!listWorkspaceLayers && (
            <div>
              <InfoMessage>
                O sistema permite apenas o carregamento de serviços WMS.
              </InfoMessage>            
            </div>
          )}
        </header>
        {listWorkspaceLayers && (
          <div className='search'>
            {showInput && (
              <div className={`content-input-search`}>
                <Input                                    
                  type="text"                   
                  fullWidth                            
                  className="text-field-search"  
                  onChange={(e) =>                    
                    e.target.value
                      ? setSearchQuery(e.target.value)
                      : setSearchQuery(null)
                    }                            
                    />
              </div>
            )}
              <button
                className={`geoservice-search`}
                onClick={(e) => {
                  e.preventDefault();
                  setshowInput(true)                
                }} 
              >              
                <Icon
                    i={"map-search"}
                />
              </button>
          </div>          
        )}
        <div className="list">
          <div className="content">
            <LayersGeoserviceList
              listWorkspaceLayers={listWorkspaceLayers}
              layers={activeModule && activeModule.camadas}
              callback={getLayersListSelection}
              highlightFirstLayer={highlightFirstLayer}               
              searchQuery={searchQuery}                
            />
            {loading && (
              <div className="loader">
                <CircularProgress color="inherit" />
              </div>
            )}
          </div>
        </div>
        <footer>
          <div className="content">
            <Button
              variant="contained"
              disabled={selected.length <= 0}
              onClick={(e) => {
                addGeoserviceLayersToMap();                         
              }}
            >
              Adicionar
            </Button>
          </div>
        </footer>
      </aside>
    </Wrap>
  );
};
